import UIComponent from "../ui/component";
import api from "../api";
import goals from "../utils/goals";

export class ProgressTranscriber extends UIComponent {
    init() {
        this.fileId = this.getFileIdFromUrl();
        this.timerInterval = null;
        this.estimate = null;
        this.initialEstimate = null;
        this.timerFinished = false;
        this.phrases = this.dataJson('phrases');
        this.phrasesInterval = null;
        this.extendedProgressInterval = null;
        this.extendedProgressStartTime = null;
        this.extendedProgressValue = null;
        this.startPhrasesRotation();
        this.checkStatus();
    }

    getFileIdFromUrl() {
        const pathParts = window.location.pathname.split("/");
        const fileId = pathParts[pathParts.length - 1];
        return fileId;
    }

    formatTime(seconds) {
        if (seconds <= 1) {
            return this.text_time.end_of_time;
        }

        if (seconds > 1800) {
            return "> 30 min";
        }

        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;

        if (minutes > 0) {
            return `~ ${minutes}:${secs.toString().padStart(2, "0")}`;
        } else {
            return `~ 00:${secs.toString().padStart(2, "0")}`;
        }
    }

    async checkStatus() {
        try {
            const response = await api.post("/api/files/status", {
                id: [Number(this.fileId)],
            });

            if (!response) {
                throw new Error("No response from server");
            }

            if (Array.isArray(response) && response.length > 0) {
                const fileData = response[0];
                this.updateProgress(fileData);
                if (
                    fileData.status !== "completed" &&
                    fileData.status !== "failed"
                ) {
                    this.progress_content.show();
                    this.failed_content.hide();
                    setTimeout(() => this.checkStatus(), 3000);
                }
            } else {
                console.warn("No file data received");
                setTimeout(() => this.checkStatus(), 5000);
            }
        } catch (error) {
            console.error("Error checking status:", error);
            setTimeout(() => this.checkStatus(), 5000);
        }
    }

    updateProgress(data) {
        if (this.estimate === null && data.estimate) {
            this.estimate = Math.round(data.estimate - data.passed);
            this.initialEstimate = data.estimate;
            
            // Проверяем, истекло ли прогнозируемое время
            const timeExpired = this.estimate <= 0;
            
            if (this.estimate > 0) {
                this.text_time.element.textContent = this.formatTime(this.estimate);
                this.startTimer();
                
                // 100% без завершенного процесса не показываем
                const progress = this.initialEstimate
                    ? Math.min(
                        ((this.initialEstimate - this.estimate) / this.initialEstimate) * 100,
                        97)
                    : 0;
                this.progress_bar.element.style.width = `${progress}%`;
                this.progress_bar.element.textContent = `${Math.round(progress)}%`;
            } else {
                this.text_time.element.textContent = this.text_time.end_of_time;
                
                // Если время истекло, вычисляем расширенный прогресс
                if (timeExpired) {
                    const passedAfterExpiry = Math.abs(this.estimate); // секунды после истечения
                    const extendedProgress = 97 + Math.min((passedAfterExpiry / 600) * 2.9, 2.9);
                    
                    // Убеждаемся, что прогресс не уменьшается при перезагрузке
                    const currentProgress = this.extendedProgressValue !== null 
                        ? Math.max(this.extendedProgressValue, extendedProgress)
                        : extendedProgress;
                    
                    this.extendedProgressValue = Math.min(currentProgress, 99.9);
                    
                    this.progress_bar.element.style.width = `${this.extendedProgressValue}%`;
                    this.progress_bar.element.textContent = `${this.extendedProgressValue.toFixed(1)}%`;
                    
                    // Запускаем расширенный прогресс, если он еще не запущен
                    if (!this.extendedProgressInterval) {
                        this.extendedProgressStartTime = Date.now() - (passedAfterExpiry * 1000);
                        this.startExtendedProgress();
                    }
                } else {
                    // Если нет данных о времени, показываем 97%
                    this.progress_bar.element.style.width = "97%";
                    this.progress_bar.element.textContent = "97%";
                }
            }
        }

        this.handleStatusChange(data.status, data.error);
    }

    getRandomPhrase() {
        if (!this.phrases || !Array.isArray(this.phrases) || this.phrases.length === 0) {
            return null;
        }
        const randomIndex = Math.floor(Math.random() * this.phrases.length);
        return this.phrases[randomIndex];
    }

    startPhrasesRotation() {
        if (this.phrasesInterval) {
            return;
        }

        // Устанавливаем первую фразу сразу
        const initialPhrase = this.getRandomPhrase();
        if (initialPhrase && this.progress_content && this.progress_content.title) {
            this.progress_content.title.element.textContent = initialPhrase;
        }

        // Меняем фразы каждые 5 секунд
        this.phrasesInterval = setInterval(() => {
            const phrase = this.getRandomPhrase();
            this.title.text(phrase);
        }, 5000);

        this.title.text(this.getRandomPhrase());
    }

    stopPhrasesRotation() {
        if (this.phrasesInterval) {
            clearInterval(this.phrasesInterval);
            this.phrasesInterval = null;
        }
    }

    handleStatusChange(status, error) {
        switch (status) {
            case "completed":
                this.stopTimer();
                this.stopExtendedProgress();
                this.progress_bar.element.style.width = "100%";
                this.progress_bar.element.textContent = "100%";
                this.text_time.element.textContent = "00:00";
                setTimeout(() => {
                    goals.reach('PromoPreloaderFinished');
                    window.location.href = `/files/${this.fileId}`;
                }, 2000);
                break;
            case "failed":
                this.stopTimer();
                this.progress_content.hide();
                this.failed_content.show();
                if (error && error === 'no_active_speech') {
                    this.failed_content.failed_error_no_voice.show();
                } else {
                    this.failed_content.failed_error.show();
                }
                break;
            case "queue":
                if (!this.timerInterval && this.estimate) {
                    this.startTimer();
                    this.progress_content.show();
                    this.failed_content.hide();
                }
                break;
        }
    }

    startTimer() {
        if (this.timerInterval || this.estimate <= 0 || this.timerFinished) {
            return;
        }

        this.timerInterval = setInterval(() => {
            if (this.estimate > 1) {
                this.text_time.element.textContent = this.formatTime(
                    this.estimate
                );
                const progress = this.initialEstimate
                    ? Math.min(
                        ((this.initialEstimate - this.estimate) / this.initialEstimate) * 100,
                        97)
                    : 0;
                this.progress_bar.element.style.width = `${progress}%`;
                this.progress_bar.element.textContent = `${Math.round(progress)}%`;
                this.estimate -= 1;
            } else {
                this.stopTimer();
                this.text_time.element.textContent = this.text_time.end_of_time;
                
                // Запускаем расширенный прогресс вместо фиксации на 97%
                this.extendedProgressStartTime = Date.now();
                this.extendedProgressValue = 97.0;
                this.progress_bar.element.style.width = "97.0%";
                this.progress_bar.element.textContent = "97.0%";
                this.startExtendedProgress();
            }
        }, 1000);
    }

    startExtendedProgress() {
        if (this.extendedProgressInterval) {
            return;
        }

        // Если extendedProgressStartTime уже установлен, вычисляем текущий прогресс на основе прошедшего времени
        if (this.extendedProgressStartTime) {
            const elapsedSeconds = Math.floor((Date.now() - this.extendedProgressStartTime) / 1000);
            const progressIncrease = Math.min((elapsedSeconds / 20) * 0.1, 2.9);
            const calculatedProgress = 97 + progressIncrease;
            
            // Используем максимальное значение между текущим и вычисленным, чтобы не уменьшать прогресс
            if (this.extendedProgressValue === null || this.extendedProgressValue < calculatedProgress) {
                this.extendedProgressValue = Math.min(calculatedProgress, 99.9);
            }
        } else if (this.extendedProgressValue === null) {
            this.extendedProgressValue = 97.0;
        }

        // Обновляем отображение с текущим значением
        this.progress_bar.element.style.width = `${this.extendedProgressValue}%`;
        this.progress_bar.element.textContent = `${this.extendedProgressValue.toFixed(1)}%`;

        // Устанавливаем интервал для увеличения прогресса каждые 20 секунд
        this.extendedProgressInterval = setInterval(() => {
            if (this.extendedProgressValue < 99.9) {
                this.extendedProgressValue = Math.min(this.extendedProgressValue + 0.1, 99.9);
                this.progress_bar.element.style.width = `${this.extendedProgressValue}%`;
                this.progress_bar.element.textContent = `${this.extendedProgressValue.toFixed(1)}%`;
            } else {
                this.stopExtendedProgress();
            }
        }, 20000);
    }

    stopExtendedProgress() {
        if (this.extendedProgressInterval) {
            clearInterval(this.extendedProgressInterval);
            this.extendedProgressInterval = null;
        }
    }

    stopTimer() {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
            this.timerInterval = null;
        }
        this.timerFinished = true;
        this.stopExtendedProgress();
        this.stopPhrasesRotation();
    }

    destroy() {
        this.stopTimer();
        this.stopExtendedProgress();
        this.stopPhrasesRotation();
        super.destroy();
    }
}
